<script lang="ts">
    import { BENEFIT_INFO_LIST } from '../constants/common';
    import { BENEFIT_ONE, FIFA_BENEFIT_BGS } from '../constants/imgList';

    import webp from '@/actions/webp';

    /** icon：灰底 + 右下角小图；fifa：FIFA 背景图（三张卡片对应 1/2/3） */
    export let type: 'icon' | 'fifa' = 'fifa';

    interface TitlePartShape {
        text: string;
        color: string;
        fontSize?: string;
    }

    const FIFA_TITLE_PARTS: TitlePartShape[][] = [
        [
            { text: 'Hasta ', color: '#ffffff' },
            { text: '2%', color: '#ffffff', fontSize: '0.28rem' },
            { text: 'de CASHBACK* ', color: '#ffffff' },
            { text: 'al pagar en ', color: '#ffffff' },
            { text: '\n', color: '#ffffff' },
            { text: 'DiDi', color: '#ffffff' }
        ],
        [
            { text: 'Hasta ', color: '#ffffff' },
            { text: '6%', color: '#ffffff', fontSize: '0.28rem' },
            { text: 'de CASHBACK* en categorías ', color: '#ffffff' },
            { text: 'seleccionadas', color: '#ffffff' }
        ],
        [
            { text: 'Hasta ', color: '#ffffff' },
            { text: '2%', color: '#ffffff', fontSize: '0.28rem' },
            { text: 'de CASHBACK* al pagar en ', color: '#ffffff' },
            { text: 'DiDi Food', color: '#ffffff' }
        ]
    ];

    function getTitleParts(
        benefit: (typeof BENEFIT_INFO_LIST)[number],
        index: number
    ): TitlePartShape[] {
        if (type === 'fifa') {
            return FIFA_TITLE_PARTS[index] ?? benefit.titleParts;
        }

        return benefit.titleParts;
    }

    function getAltText(benefit: (typeof BENEFIT_INFO_LIST)[number]): string {
        return benefit.titleParts.map((part) => part.text).join('');
    }
</script>

<div class="benefit-info" class:benefit-info--fifa={type === 'fifa'}>
    <div class="benefit-header">Beneficios</div>

    <div class="benefit-cards">
        {#each BENEFIT_INFO_LIST as benefit, i (benefit.icon ?? i)}
            <div
                class="benefit-card"
                class:benefit-card--fifa={type === 'fifa'}
                class:benefit-card--icon={type === 'icon'}
                use:webp={type === 'fifa' ? FIFA_BENEFIT_BGS[i] : ''}
            >
                <div class="card-title">
                    {#each getTitleParts(benefit, i) as part, idx (idx)}
                        {#if part.text === '\n'}
                            <br />
                        {:else}
                            <span
                                style:color={part.color}
                                style:font-size={part.fontSize}
                            >
                                {part.text}
                            </span>
                            {#if idx < getTitleParts(benefit, i).length - 1 &&
                                getTitleParts(benefit, i)[idx + 1]?.text !== '\n'}
                                {' '}
                            {/if}
                        {/if}
                    {/each}
                </div>

                {#if type === 'icon'}
                    <div class="icon-box">
                        <img
                            use:webp
                            src={benefit.icon ?? BENEFIT_ONE}
                            alt={getAltText(benefit)}
                        />
                    </div>
                {/if}
            </div>
        {/each}
    </div>
</div>

<style lang="scss" scoped>
    .benefit-info {
        width: 100%;
        max-width: 750px;
        padding: 0 32px;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
    }

    .benefit-header {
        margin: 0 0 24px 8px;
        font-family: DiDiSans-Pro-Bold;
        font-size: 32px;
        line-height: 40px;
        color: #0c0c0d;
    }

    .benefit-cards {
        width: 100%;
        display: flex;
        gap: 16px;
    }

    .benefit-card {
        width: 218px;
        height: 260px;
        border-radius: 16px;
        padding: 24px 22px 0 24px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
    }

    .benefit-card--icon {
        align-items: center;
        background-color: #f2f2f5;
    }

    .benefit-card--fifa {
        align-items: flex-start;
        background-color: #ff5f14;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center bottom;
    }

    .card-title {
        position: relative;
        z-index: 1;
        font-family: DiDiSans-Pro-Bold;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0;
        color: #111a34;
        word-break: break-word;
    }

    .benefit-card--fifa .card-title {
        color: #ffffff;
    }

    .icon-box {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 140px;
        height: 100px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        pointer-events: none;
    }

    .icon-box img {
        width: 140px;
        height: 100px;
        object-fit: contain;
    }
</style>
